import React from 'react'
import { useAppSelector } from '@/store'
import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'

import { scopeLabel } from './overrideScope'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

const EntityCell: React.FC<GridCellProps> = ({ dataItem }) => {
  const companies = useAppSelector((state) => state.identity.tickmillCompanies)
  return (
    <td>
      {scopeLabel(
        dataItem.tickmillCompanyId,
        companies.map((c) => ({ id: c.id, name: c.name }))
      )}
    </td>
  )
}

const CountryCell: React.FC<GridCellProps> = ({ dataItem }) => {
  const countries = useAppSelector((state) => state.identity.countries)
  return (
    <td>
      {scopeLabel(
        dataItem.countryId,
        countries.map((c) => ({ id: c.id, name: c.name }))
      )}
    </td>
  )
}

const PaymentProviderCell: React.FC<GridCellProps> = ({ dataItem }) => {
  const providers = useAppSelector((state) => state.wallet.paymentProviders)
  return (
    <td>
      {scopeLabel(
        dataItem.paymentProviderId,
        providers.map((p) => ({ id: p.id, name: p.name }))
      )}
    </td>
  )
}

const ClientTypeCell: React.FC<GridCellProps> = ({ dataItem }) => {
  const clientTypes = useAppSelector((state) => state.clients.types)
  return (
    <td>
      {scopeLabel(
        dataItem.clientTypeId,
        clientTypes.map((t) => ({ id: t.id, name: t.name }))
      )}
    </td>
  )
}

const WalletTypeCell: React.FC<GridCellProps> = ({ dataItem }) => {
  const walletTypes = useAppSelector((state) => state.wallet.walletType)
  return (
    <td>
      {scopeLabel(
        dataItem.walletTypeId,
        walletTypes.map((t) => ({ id: t.id, name: t.name }))
      )}
    </td>
  )
}

const EnabledCell: React.FC<GridCellProps> = ({ dataItem }) => (
  <td>{dataItem.enabled ? 'Yes' : 'No'}</td>
)

export const scopeColumns: GridColumn[] = [
  { title: 'Entity', field: 'tickmillCompanyId', cell: EntityCell, show: true },
  { title: 'Country', field: 'countryId', cell: CountryCell, show: true },
  { title: 'Method', field: 'paymentProviderId', cell: PaymentProviderCell, show: true },
  { title: 'Client Type', field: 'clientTypeId', cell: ClientTypeCell, show: true },
  { title: 'Wallet Type', field: 'walletTypeId', cell: WalletTypeCell, show: true },
]

export const enabledColumn: GridColumn = {
  title: 'Enabled',
  field: 'enabled',
  cell: EnabledCell,
  show: true,
}
